export const CATEGORIES_FETCH_PROCESSING = 'CATEGORIES_FETCH_PROCESSING'
export const CATEGORIES_FETCH_SUCCESS = 'CATEGORIES_FETCH_SUCCESS'
export const CATEGORIES_FETCH_ERROR = 'CATEGORIES_FETCH_ERROR'
